<template>
  <div
    v-if="hasSupplementalLink"
    class="publication-links"
    >
    <ul
      class="supplemental"
      data="publication-links"
      >
      <li
        v-for="(pdf, index) in pdfs"
        :key="index"
        class="supplemental__item--list"
        >
        <a
          :href="pdf.Url"
          class="icon-link"
          v-html="PdfCTA(pdf.TranslationKey)"
          />
      </li>
      <li
        v-if="hasExhibitionLink"
        class="supplemental__item--list"
        >
        <a
          :href="exhibitionURL"
          class="icon-link"
          v-html="exhibitionCTA"
          />
      </li>
      <li
        v-if="hasStoreItem"
        class="supplemental__item--list"
        >
        <a
          :href="storeURL"
          class="icon-link"
          v-html="storeCTA"
          target="_blank"
          />
      </li>
    </ul>
  </div>
</template>

<script>
  import { addSvgToEnd } from 'Helpers/embedSVG';
  import i18n from '../../utils/i18n.js';

  export default {
    props: {
      exhibitionId: {type: Number, required: true},
      pdfs: {type: Array, required: false, default:null},
      sku: {type: String, required: true},
    },

    data: function() {
      return {
        price: '',
        storeLink: '',
        i18n: new i18n(),
      };
    },

    computed: {
      hasSupplementalLink(){
        return this.hasStoreItem || this.hasExhibitionLink || this.hasPdfs;
      },

      hasPdfs() {
        return (this.pdfs != null && this.pdfs.length > 0);
      },

      hasExhibitionLink() {
        return this.exhibitionId > 0;
      },

      exhibitionURL() {
        return `/calendar/exhibitions/${this.exhibitionId}`;
      },

      exhibitionCTA() {
        return addSvgToEnd(this.i18n.t('publication__exhibition__view-link'), 'icon-link--control__text--list', 'icon__arrow--16--stroke.svg', 'icon-link__svg');
      },


      hasStoreItem() {
        return this.price != '';
      },

      storeURL() {
        return  this.storeLink;
      },

      storeCTA() {
        return addSvgToEnd(this.i18n.t('publication__store-link'), 'icon-link--control__text--list', 'icon__arrow--16--stroke.svg', 'icon-link__svg--315');
      },
    },

    created() {
      if (this.sku.length > 0 ) {
        this.fetchStoreURL();
      }
      this.updateImageUrl();
    },

    updated() {
      this.updateImageUrl();
    },

    methods: {
      updateImageUrl() {
        if (this.hasStoreItem) {
          this.$emit('imageUrl', this.storeURL);
        } else if (this.hasExhibitionLink) {
          this.$emit('imageUrl', this.exhibitionURL);
        } else if (this.hasPdfs) {
          let url = this.pdfs[this.pdfs.length -1].Url;
          this.$emit('imageUrl', url);
        } else {
          this.$emit('imageUrl', "");
        }
      },

      fetchStoreURL: async function() {
        const storeApiUrl = `/api/publications/${this.sku}`;

        await fetch(storeApiUrl)
          .then(res => res.json())
          .then(res => {
            if (res != []){
              this.price = res.price;
              this.storeLink = res.store_url;
            }
          })
          .catch(error => {
            console.log(storeApiUrl + ' failed with error: ', error);
          });
      },

      PdfCTA(tkey) {
        var cta = this.i18n.t(tkey);
        return addSvgToEnd(cta, 'icon-link--control__text--list', 'icon__pdf--24.svg', 'icon-link__svg');
      },
    },
  };
</script>
